import helper from 'helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('trattamenti');
export const actions = helper.createActions('trattamenti', actionTypes);
